import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import MovieDetails from './pages/MovieDetails';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import About from './pages/About';
import RequestMovie from './pages/RequestMovie';
import NotFound from './pages/NotFound';
import PrivateRoute from './components/PrivateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/request-movie" element={<RequestMovie />} />
      <Route path="/movie/:slug" element={<MovieDetails />} />
      <Route path={process.env.REACT_APP_ADMIN_PATH} element={<AdminLogin />} />
      <Route
        path="/admin/*"
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
